import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UserService } from 'src/app/services/user.service';
import { AdministracionNivelVentasService } from '../../Service/administracion-nivel-ventas.service';
import { CurrencyPipe } from '@angular/common';
import { NeoNivelVentaIntermediarioDTO } from '../../Model/neoNivelVentaIntermediarioDTO';
declare var $: any;

@Component({
    selector: 'app-administrar-nivel-ventas',
    templateUrl: './administrar-nivel-ventas.component.html',
    styleUrls: ['./administrar-nivel-ventas.component.scss'],
    standalone: false
})
export class AdministrarNivelVentasComponent implements OnInit {
  listaNeoNivelVentasIntermediarioDTO: NeoNivelVentaIntermediarioDTO[] = [];
  neoNivelVentaIntermediarioDTO: NeoNivelVentaIntermediarioDTO;
  editarNivelVentaIntermediarioDTO: NeoNivelVentaIntermediarioDTO;
  eliminarNivelVentaIntermediarioDTO: NeoNivelVentaIntermediarioDTO;
  adminVentasForm: UntypedFormGroup;
  editarVentasForm: UntypedFormGroup;
  listaIntermediarios: any[];
  idCliente: number;
  idUsuario: number;
  paginaActual: number = 1;
  totalPaginas: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _sweetAlert: SweetAlertService,
    public router: Router,
    public _nivelVentasService: AdministracionNivelVentasService,
    private _user: UserService,
    public pipe: CurrencyPipe
  ) { }

  ngOnInit(): void {
    this.idCliente = this._user.getUser().idCliente;
    this.idUsuario = this._user.getUser().idUsuario;

    this.adminVentasForm = this.formBuilder.group({
      idCliente: [''],
      nivelVentasInicial: ['', Validators.required],
      nivelVentasFinal: ['', Validators.required]
    });

    this.editarVentasForm = this.formBuilder.group({
      nivelVentasInicial: [0, Validators.required],
      nivelVentasFinal: [0, Validators.required],
      justificacion: ['', Validators.required],
    });

    this.eliminarNivelVentaIntermediarioDTO = new NeoNivelVentaIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );

    this.setPipeForm();
    // listado nivel ventas
    this.obtenerNivelVentasIntermediarioById();
  }

  // validaciones
  validateForm() {
    if (this.adminVentasForm.valid) {
      this.crearNivelVenta();
    } else {
      this.adminVentasForm.markAllAsTouched();
    }
  }

  isValidFormEditar(field: string) {
    return (
      (this.editarVentasForm.get(field)?.dirty ||
        this.editarVentasForm.get(field)?.touched) &&
      this.editarVentasForm.get(field)?.invalid
    );
  }

  isValidForm(field: string) {
    return (
      (this.adminVentasForm.get(field)?.dirty ||
        this.adminVentasForm.get(field)?.touched) &&
      this.adminVentasForm.get(field)?.invalid
    );
  }
  // fin validacion

  // listados
  obtenerNivelVentasIntermediarioById() {
    this._nivelVentasService
      .getNivelVentasByIntermediario(this.idCliente,this.paginaActual)
      .subscribe((response: any) => {
        if (response.length != 0) {
          this.listaNeoNivelVentasIntermediarioDTO = response.data;
          this.totalPaginas = response.paginasTotales;
        }
      }, (error) => {
        this._sweetAlert.errorModal("Error", true, "Ocurrió un error en el servicio.")
      })
  }
  // fin listados

  crearNivelVenta() {
    let json: any;
    let ventasInicial = Number(this.adminVentasForm.get('nivelVentasInicial').value.replaceAll(',', ''));
    let ventasFinal = Number(this.adminVentasForm.get('nivelVentasFinal').value.replaceAll(',', ''));
    this.adminVentasForm.get('idCliente').setValue(this.idCliente);
    json = {
      idCliente: Number(this.adminVentasForm.get('idCliente').value),
      nivelVentasInicial: ventasInicial,
      nivelVentasFinal: ventasFinal,
      idUsuario:Number(this.idUsuario)
    }
    if (ventasInicial < ventasFinal) {
      this.callSerciveSaveNivelVenta(json);
      this.adminVentasForm.reset();
    } else {
      this._sweetAlert.errorModal("Error", true, 'El rango inicial es mayor que el rango final');
    }
  }

  callSerciveSaveNivelVenta(body: any) {
    this._nivelVentasService.saveNivelVenta(body).subscribe((response: any) => {
      if (response.exitoso && response.error == undefined) {
        this._sweetAlert.successModal("Éxito", false, "Rango agregado");
        this.obtenerNivelVentasIntermediarioById();
      } else {
        this._sweetAlert.errorModal("Error", true, response.error);
      }
    }, (error) => {
      this._sweetAlert.errorModal("Error", true, "Ocurrió un error en el servicio.")
    })
  }

  editarFilaNivelVentas(id: number) {
    this.editarNivelVentaIntermediarioDTO =
      this.listaNeoNivelVentasIntermediarioDTO[id];
    this.editarVentasForm
      .get('nivelVentasInicial')
      .setValue(this.editarNivelVentaIntermediarioDTO.nivelVentasInicial);
    this.editarVentasForm
      .get('nivelVentasFinal')
      .setValue(this.editarNivelVentaIntermediarioDTO.nivelVentasFinal);
    this.editarVentasForm
      .get('justificacion')
      .setValue(this.editarNivelVentaIntermediarioDTO.justificacion);
    $('#editModal').modal('show');
  }

  editarNivelVentas() {
    let json;
    this.editarNivelVentaIntermediarioDTO.idCliente = Number(this.idCliente);
    this.editarNivelVentaIntermediarioDTO.idUsuario = Number(this.idUsuario);
    this.editarNivelVentaIntermediarioDTO.justificacion = this.editarVentasForm.get('justificacion').value;
    this.editarNivelVentaIntermediarioDTO.nivelVentasInicial = Number(this.editarVentasForm.get('nivelVentasInicial').value.replaceAll(',', ''));
    this.editarNivelVentaIntermediarioDTO.nivelVentasFinal = Number(this.editarVentasForm.get('nivelVentasFinal').value.replaceAll(',', ''));
    if (this.editarNivelVentaIntermediarioDTO.nivelVentasInicial <
      this.editarNivelVentaIntermediarioDTO.nivelVentasFinal) {
      this.callServiceUpdateNivelVentas(this.editarNivelVentaIntermediarioDTO);
      $('#editModal').modal('hide');
    } else {
      this._sweetAlert.errorModal("Error", true, 'El rango inicial es mayor que el rango final');
    }
  }

  callServiceUpdateNivelVentas(body: any) {
    this._nivelVentasService.updateNivelVenta(body).subscribe((response: any) => {
      if (response.exitoso) {
        this._sweetAlert.successModal('Rango modificado exitosamente');
        this.obtenerNivelVentasIntermediarioById();
      } else {
        this._sweetAlert.errorModal("Error", true, response.error);
      }
    }, (error) => {
      this._sweetAlert.errorModal("Error", true, "Ocurrió un error en el servicio.")
    })
  }

  // Borrar nivel venta
  borrarFilaNivelVenta(id: number) {
    this.eliminarNivelVentaIntermediarioDTO =
      this.listaNeoNivelVentasIntermediarioDTO[id];
    this.eliminarNivelVentaIntermediarioDTO.idCliente = Number(this.idCliente);
    this.eliminarNivelVentaIntermediarioDTO.idUsuario = Number(this.idUsuario);
    this.eliminarNivelVentaIntermediarioDTO.justificacion = "";
    $('#deleteModal').modal('show');
  }

  borrarVenta() {
    if (this.eliminarNivelVentaIntermediarioDTO != null) {
      if (this.eliminarNivelVentaIntermediarioDTO.justificacion != '') {
        this.callServiceDeleteNivelVenta(this.eliminarNivelVentaIntermediarioDTO);
      } else {
        this._sweetAlert.errorModal("Error", true, 'Ingrese la justificación');
      }
    } else {
      this._sweetAlert.errorModal("Error", true, 'No fue posible cargar los datos');
      $('#deleteModal').modal('hide');
    }
  }

  callServiceDeleteNivelVenta(body: any) {
    this._nivelVentasService.deleteNivelVenta(body).subscribe((response: any) => {
      if (response.exitoso) {
        this._sweetAlert.successModal('Rango borrado exitosamente');
        $('#deleteModal').modal('hide');
        this.obtenerNivelVentasIntermediarioById();
      } else {
        this._sweetAlert.errorModal("Error", true, 'No fue posible borrar el rango');
        $('#deleteModal').modal('hide');
      }
    }, (error) => {
      this._sweetAlert.errorModal("Error", true, "Ocurrió un error en el servicio.")
    })
  }

  // fin borrar nivel venta

  setPipeForm() {
    this.adminVentasForm.controls['nivelVentasInicial'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.adminVentasForm.patchValue(
            {
              nivelVentasInicial: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.adminVentasForm.controls['nivelVentasFinal'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.adminVentasForm.patchValue(
            {
              nivelVentasFinal: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.editarVentasForm.controls['nivelVentasInicial'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.editarVentasForm.patchValue(
            {
              nivelVentasInicial: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.editarVentasForm.controls['nivelVentasFinal'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.editarVentasForm.patchValue(
            {
              nivelVentasFinal: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
  }

  goHome() {
    this.router.navigate(['/intermediario/home']);
  }
    // paginado
    selectPage(pageNumber: number) {
      this.paginaActual=pageNumber;
      this.obtenerNivelVentasIntermediarioById();
    }

}

